<template>
    <div v-if="alert">
        <NotificationMessage
            v-for="_alert in alert"
            :key="_alert.id"
            :notification="_alert"
        />
    </div>
</template>

<script>
import NotificationMessage from './NotificationMessage.ce.vue';

import { storeToRefs } from 'pinia';
import { useAlertStore } from '@/stores';

export default {
    name: 'Notifications-list',
    components: {
        NotificationMessage
    },
    setup() {
        const alertStore = useAlertStore();
        const { alert } = storeToRefs(alertStore);
        return { 
            alert
        };
    },
}
</script>

<style>

</style>
